module.exports = __webpack_public_path__ + "img/154.59d89805.jpg";